import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';

import MuiTextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiFormControl from '@material-ui/core/FormControl';
import MuiFormControlLabel from '@material-ui/core/FormControlLabel';
import MuiFormHelperText from '@material-ui/core/FormHelperText';
import MuiRadioGroup from '@material-ui/core/RadioGroup';
import MuiRadio from '@material-ui/core/Radio';
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import * as API from 'api';
import { useMutation } from 'react-query';

const RecoupLedger = API.RecoupLedgers();

const styles = theme => ({
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '4px',
    marginBottom: '10px',
  },
  formControl: {
    width: '100%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const DialogAddTransaction = ({ open, onClose, onCreated, recoup_account_id, ledger, ...props }) => {
  const { classes } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [type, setType] = useState('expense');
  const [formData, setFormData] = useState(ledger || {});

  const addTransactionMutation = useMutation(formData => RecoupLedger.addLedger(recoup_account_id, formData), {
    onSuccess: data => {
      setError(null);
      onCreated(recoup_account_id);
      setFormData({});
    },
    onError: error => {
      let description, meta;

      if (Array.isArray(error?.data?.errors)) {
        description = error?.data?.errors[0].description;
        meta = error?.data?.errors[0].meta;
      } else {
        description = 'Error';
        meta = error?.data;
      }

      const errorMsg = `${description} - ${typeof meta === 'object' ? JSON.stringify(meta, 0, 2) : meta}`;
      setError(errorMsg);
      alert(errorMsg);
    },
  });

  // Data
  useEffect(() => {
    setIsDialogOpen(open);
  }, [open]);

  useEffect(() => {
    if (!isDialogOpen) {
      setFormData({});
      onClose();
    }
  }, [isDialogOpen]);

  const [error, setError] = useState(null);

  function updateForm({ target: { value, id } }) {
    setFormData({ ...formData, [id]: value });
  }

  const handleFormSubmit = async () => {
    const { effective_at, notes, amount_usd } = formData;
    const saveItem = {
      effective_at,
      notes,
      amount_usd: type === 'expense' ? -1 * Number(amount_usd) : Number(amount_usd),
    };
    await addTransactionMutation.mutateAsync(saveItem);
  };

  const handleDialogClose = () => setIsDialogOpen(false);

  return (
    <MuiDialog open={isDialogOpen} onClose={handleDialogClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Add an expense/credit</MuiDialogTitle>
      <MuiDialogContent>
        <div className={classes.formRow}>
          <MuiFormControl className={classes.formElement}>
            <MuiFormHelperText>Date</MuiFormHelperText>
            <input
              type="date"
              id="effective_at"
              onChange={updateForm}
              value={formData.effective_at ? new Date(formData.effective_at).toISOString().split('T')[0] : ''}
            />
          </MuiFormControl>
        </div>
        <div className={classes.formRow}>
          <MuiFormControl variant="outlined" className={classes.formControl} name="type">
            <MuiRadioGroup
              row
              aria-label="type"
              name="type"
              value={type}
              onChange={(_evt, value) => {
                setType(value);
              }}>
              <MuiFormControlLabel value="expense" control={<MuiRadio />} label="Expense" />
              <MuiFormControlLabel value="credit" control={<MuiRadio />} label="Credit" />
            </MuiRadioGroup>
          </MuiFormControl>
        </div>
        <div className={classes.formRow}>
          <MuiTextField
            value={formData.amount_usd || 0}
            onChange={updateForm}
            label="Amount"
            type="number"
            variant="outlined"
            id="amount_usd"
            className={classes.formControl}
            inputProps={{
              min: 0,
            }}
            InputProps={{
              startAdornment: <MuiInputAdornment position="start">$ {type === 'expense' && ' - '} </MuiInputAdornment>,
            }}
          />
        </div>
        <div className={classes.formRow}>
          <MuiTextField
            value={formData.notes}
            onChange={updateForm}
            label="Notes"
            variant="outlined"
            id="notes"
            className={classes.formControl}
            multiline
            minRows={3}
            maxRows={6}
          />
        </div>
      </MuiDialogContent>
      <MuiDialogActions className={classes.dialogFooter}>
        <MuiButton variant="contained" onClick={handleDialogClose}>
          Cancel
        </MuiButton>
        <MuiButton variant="contained" color="primary" type="submit" onClick={handleFormSubmit}>
          Create
        </MuiButton>
      </MuiDialogActions>
    </MuiDialog>
  );
};

export default withStyles(styles)(DialogAddTransaction);
